import { render, staticRenderFns } from "./NormalSearchNav354.vue?vue&type=template&id=622f4ad4&scoped=true&"
import script from "./NormalSearchNav354.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav354.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622f4ad4",
  null
  
)

export default component.exports